import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const AuditFilters = ({ filters, actionTypes, admins, onFilterChange, onClearFilters }) => {
    const hasActiveFilters = filters.admin_user_id || filters.action_type;

    return (
        <div className="flex flex-row flex-wrap w-full gap-3 items-center">
            {/* Action Type Filter */}
            <div className="flex flex-col w-full gap-1">
                <label className="text-sm text-font-secondary font-medium">Action Type</label>
                <select
                    value={filters.action_type}
                    onChange={(e) => onFilterChange({ action_type: e.target.value })}
                    className="px-3 py-2 button-container rounded text-sm border border-border focus:border-primary focus:outline-none"
                >
                    <option value="">All Actions</option>
                    {actionTypes.map((action) => (
                        <option key={action} value={action}>
                            {action.replace(/_/g, ' ')}
                        </option>
                    ))}
                </select>
            </div>

            {/* Admin Filter */}
            <div className="flex flex-col w-full gap-1">
                <label className="text-sm text-font-secondary font-medium">Admin User</label>
                <select
                    value={filters.admin_user_id}
                    onChange={(e) => onFilterChange({ admin_user_id: e.target.value })}
                    className="px-3 py-2 button-container rounded text-sm border border-border focus:border-primary focus:outline-none"
                >
                    <option value="">All Admins</option>
                    {admins.map((admin) => (
                        <option key={admin.admin_user_id} value={admin.admin_user_id}>
                            {admin.admin_name || admin.admin_email || admin.admin_user_id}
                        </option>
                    ))}
                </select>
            </div>
            {hasActiveFilters && (
                <button
                    onClick={onClearFilters}
                    className="text-sm text-font-primary h-fit flex flex-row items-center whitespace-nowrap hover:text-error flex items-center gap-1 transition-colors"
                >
                    <Icon icon="mdi:close-circle" className="text-xl text-error" />
                    <span>Clear Filters</span>
                </button>
            )}
        </div>
    );
};

export default AuditFilters;

